/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Settings_Group_SystemInputs */

const cs_nav_settings_group_system = /** @type {(inputs: Nav_Settings_Group_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systém`)
};

const en_nav_settings_group_system = /** @type {(inputs: Nav_Settings_Group_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

/**
* | output |
* | --- |
* | "System" |
*
* @param {Nav_Settings_Group_SystemInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_settings_group_system = /** @type {((inputs?: Nav_Settings_Group_SystemInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Settings_Group_SystemInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_settings_group_system(inputs)
	return cs_nav_settings_group_system(inputs)
});